import { ChangeDetectionStrategy, Component, Input, ViewEncapsulation } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslocoPipe } from '@jsverse/transloco';
import { Button } from 'primeng/button';

export type ErrorDialogData = {
  title?: string;
  content?: string;
  showReloadButton?: boolean;
  primaryButtonText?: string;
  secondaryButtonText?: string;
};

@Component({
  selector: 'app-error-dialog',
  templateUrl: './error-dialog.component.html',
  imports: [CommonModule,TranslocoPipe, Button],
  encapsulation: ViewEncapsulation.None,
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ErrorDialogComponent {
  @Input() data: any;
  @Input() close: ((event?: any) => void) | undefined;
  @Input() okClicked: ((feedback: string) => void) | undefined;

  reload() {
    location.reload();
  }
}
